import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { NgxSpinnerService } from 'ngx-spinner';
import { ClassService } from '../services/class.service';
import { CompanyDetailsService } from '../services/company-details.service';
import { LoaderService } from '../services/loader.service';
import { LogService } from '../services/log.service';
import { PaymentService } from '../services/payment.service';
import { ResultService } from '../services/result.service';
import { SemesterService } from '../services/semester.service';
import { UserService } from '../services/user.service';
@Component({
  selector: 'app-semester-result',
  templateUrl: './semester-result.component.html',
  styleUrls: ['./semester-result.component.css']
})
export class SemesterResultComponent implements OnInit {
  public selectedIndex = 2;
  public test;
  public tcp;
  public mark;
  public attainedGrade;
  public details = [];
  public sessions = [];
  public semester_alias = [];
  public semesters = [];
  public tabs = [];
  public reg;
  public data;
  public attained;
  public tattained;
  public gradee;

  // public total = 0;
  // public q;
  // public cumUnit = 0;
  // public cumTotal = 0;
  // public cumTotalAttainable = 0;

  public courses = [];
  public x;
  public company;
  public studentPassport;
  public firstname;
  public lastname;
  public middlename;
  public student_id;
  public branch_id;
  public matric_no;
  public session_year;
  public semester;
  public studentLevel;
  public isFullyLoaded;
  public dataLength;
  public _point;
  public system;
  public paid;
  public resultPaymentAmount = 0;
  public resultPaymentCharge = 0;

  public program;
  public dept;

  // PSEC PRINT VARIABLES
  public classArr = [];
  public reportArr = [];
  public totalReportArr = [];
  public cd_id;
  public termd_id;
  public sum;
  public gradeArr = [];
  public classTeacher = "";
  public resultSetArr; controlCA1; controlCA2; controlExam;
  public studentReport = [];
  public isTeacher = false;
  public isPrincipal = false;
  public obtainable = { ca1: 0, ca2: 0, exam: 0, total: 0 };
  public menuArr = [
    { menu_id: 1, menu_name: "Teacher" },
    { menu_id: 2, menu_name: "Principal" }
  ]
  public staff_id;
  public commentArr = [];
  public showSubjectPosition = true;
  public showClassPosition = true;
  public showDOB = true;
  public omitPosition = false;
  public term_id;
  public currentTerm;
  public fetchForAll = false;

  public paymentEligible: any = { control: true };


  // variables for term report
  public term1 = 0;
  public term2 = 0;
  public term3 = 0;

  public ca1Name = ""
  public ca2Name = ""
  public examName = ""

  public ca1;
  public ca2;
  public exam;

  public classTotalTermReport: any = [];
  public classTermReport: any = [];
  public studentTermReport: any = [];
  constructor (
    private spinner: NgxSpinnerService,
    private _resultService: ResultService,
    private _companyDetailsService: CompanyDetailsService,
    public cl: ClassService,
    private _userService: UserService,
    public dialog: MatDialog,
    public _paymentService: PaymentService,
    private _loaderService: LoaderService,
    public sem: SemesterService,
    public log: LogService
  ) { }

  sortByKey (array, key) {
    return array.sort(function (a, b) {
      var x = parseInt(a[key]); var y = parseInt(b[key]);
      return ((x > y) ? -1 : ((x < y) ? 1 : 0));
    });
  }

  sortByKey2 (array, key) {
    return array.sort(function (a, b) {
      var x = parseInt(a[key]); var y = parseInt(b[key]);
      return ((x < y) ? -1 : ((x > y) ? 1 : 0));
    });
  }

  formatDate (date) {
    var d = new Date(date),
      month = '' + (d.getMonth() + 1),
      day = '' + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2)
      month = '0' + month;
    if (day.length < 2)
      day = '0' + day;

    return [year, month, day].join('-');
  }

  public paymentPercentage = [];

  watchProgram () {
    this._userService.programChange.subscribe(data => {
      this.ngOnInit(1);
    })
  }

  public eligibilityMessage = "";
  ngOnInit (time = 0) {
    if (time == 0) {
      this.log
        .addLog({
          action: "Access",
          component: `${this.system == 'tert' ? 'Semester' : 'Term'} Result`,
          details: `Accessed ${this.system == 'tert' ? 'Semester' : 'Term'} Result`,
        }).subscribe(data => { });
    }
    this._paymentService.getPaymentEligibility({ key: 'result' }).subscribe(data => {
      this.paymentEligible = data;
      this._paymentService.getPaymentPercentageByTerm({ key: 'result' }).subscribe(data => {
        this.paymentPercentage = data;
        this.init(time);
      })
      // if(this.paymentEligible.control == false){
      //   if(!this.paymentEligible.control){
      //     this.dialog.open(MessagesComponent, {
      //         disableClose: true,
      //         data: {for: 'payment_eligibility', message: `You need to have paid ${this.paymentEligible.value}% of the tuition to be able to view results`}
      //     })
      //   }
      //   return;
      // }else{
      //   this.init(time);
      // }
    });
  }

  // sortByKey(array, key) {
  //   return array.sort(function (a, b) {
  //     var x = a[key];
  //     var y = b[key];
  //     return x > y ? 1 : x < y ? -1 : 0;
  //   });
  // }

  init (time) {
    // this.cumUnit = 0;
    // this.cumTotal = 0;
    // this.cumTotalAttainable = 0;
    if (time == 0) {
      this.watchProgram()
    }
    this.cl.getComments().subscribe((data) => {
      this.commentArr = data;
    });
    this.system = localStorage.getItem("p_system");
    this._loaderService.emitChange(true);
    this.spinner.show();
    setTimeout(() => {
      this.spinner.hide();
    }, 3000);
    //this.details = this._profileService.getCourseDetails();
    this._resultService.companyRequiresResultPayment().subscribe(_data => {
      if (_data.status === true) {
        this.resultPaymentAmount = parseFloat(_data.amount);
        this.resultPaymentCharge = parseFloat(_data.charge);
        this._resultService.checkResultPaymentStatus().subscribe(data => {
          this.paid = data.status;
          // console.log('paid  ', this.paid);
        })

      } else {
        this.paid = true;
      }
    })


    this._companyDetailsService.getDetails().subscribe(company => {
      company.allow_portal_result_print = !!Number(company.allow_portal_result_print); // to boolean
      this.company = company;

      this._resultService.getGrades().subscribe(grades => {
        this._resultService.semesterResult().subscribe(data => {
          this.data = data;
          // console.log(data, "SEM RES");
          this.dataLength = this.data.length;
          this.details.length = 0;
          this.sessions.length = 0;
          this.semesters.length = 0;

          const totalPaid = this.paymentPercentage.reduce((a, b) => a + b.total_paid, 0)
          const totalBill = this.paymentPercentage.reduce((a, b) => a + b.total_bill, 0);
          const totalPaidPercentage = (totalPaid / totalBill) * 100;

          for (let i in data) {
            if (this.sessions.indexOf(data[i].session_year) <= -1) {
              this.sessions.push(data[i].session_year);
            }
            if (this.semesters.indexOf(data[i].term) <= -1) {
              this.semesters.push(data[i].term);
              this.semester_alias.push(data[i].term.charAt(0));
            }
          }




          for (let i in this.sessions) {
            const sessionPayments = this.paymentPercentage.filter(each => each.session_year == this.sessions[i])
            const totalPaidInSession = sessionPayments.reduce((a, b) => a + b.total_paid, 0)
            const totalBillInSession = sessionPayments.reduce((a, b) => a + b.total_bill, 0);
            const totalPaidPercentageInSession = (totalPaidInSession / totalBillInSession) * 100;


            for (let j in this.semesters) {
              let td_index = data.findIndex(d => d.session_year == this.sessions[i] && d.term == this.semesters[j]);
              let eligibilityMessage = "";
              let eligible = false;
              let percentageString = "";

              if (td_index >= 0) {
                let termd_id = data[td_index].termd_id;

                switch (company.fee_access_calculation_method) {
                  case "across_sessions":
                    percentageString = `${totalPaidPercentage.toFixed(2)}%`;
                    eligibilityMessage = `You need to have paid ${this.paymentEligible.value}% of the tuition to be able to view results`;
                    eligible = totalPaidPercentage >= this.paymentEligible.value
                    break;

                  case "per_session":
                    percentageString = `${totalPaidPercentageInSession.toFixed(2)}%`;
                    eligibilityMessage = `You need to have paid ${this.paymentEligible.value}% of the ${this.sessions[i]} tuition to be able to view results`;
                    eligible = totalPaidPercentageInSession >= this.paymentEligible.value
                    break;

                  default: //per_term
                    eligibilityMessage = `You need to have paid ${this.paymentEligible.value}% of the ${this.sessions[i]} ${this.semesters[j]} tuition to be able to view results`;
                    let termPercentageData = this.paymentPercentage.find(p => p.termd_id == termd_id);
                    if (termPercentageData) {
                      eligible = termPercentageData.percentage >= this.paymentEligible.value;
                      percentageString = `${termPercentageData.percentage?.toFixed(2)}%`;
                    }
                    break;
                }

                if (!this.paymentEligible.value) {
                  eligible = true;
                }
                // if (this.company?.adm_initial == 'NBTS' && this.sessions[i].split('/')[1] < 2023) {
                //   eligible = true;
                // }

                this.details.push({
                  session_year: this.sessions[i],
                  semester: this.semesters[j],
                  termd_id, percentageString,
                  eligible, eligibilityMessage,
                  tab: data.filter(x => x.session_year == this.sessions[i]
                    && x.term == this.semesters[j])
                });
                this.details = this.sortByKey2(this.details, 'termd_id');

              }

            }
          }

          //get grades, comment and point for each course

          if (this.system == 'tert') {
            for (let d in this.details) {
              // this.details[d]['cumPoint'] = 0;
              for (let t in this.details[d].tab) {
                for (let g in grades) {
                  if (this.details[d].tab[t].marks >= grades[g].score) {
                    this.details[d].tab[t]._point = grades[g].point * this.details[d].tab[t].unit;
                    this.details[d].tab[t]._grade = grades[g].grade;
                    this.details[d].tab[t]._comment = grades[g].comment;

                    // this.details[d].cumPoint += this.details[d].tab[t]._point;
                    // this.details[d].cumUnit += this.details[d].tab[t].unit;
                    break;
                  }

                }
              }

            }

          } else if (this.system == 'psec') {
            for (let d in this.details) {
              for (let t in this.details[d].tab) {
                for (let g in grades) {
                  if (this.details[d].tab[t].marks >= grades[g].score) {

                    this.details[d].tab[t]._grade = grades[g].grade;
                    this.details[d].tab[t]._comment = grades[g].comment;

                    break;
                  }

                }
              }

            }
          }
          // if(dd[y].marks > grades[g].score){
          //   this.gradee =  (!grades[g].point) ? 0 : grades[g].point;
          //   //console.log(this.gradee);
          //   this._point = this.gradee * dd[y].marks;
          //   break;
          // } 

          let cumUnit = 0;
          let cumTotal = 0;
          let cumTotalAttainable = 0

          for (let x in this.details) {
            let q = 0
            let total = 0

            // this.cumUnit = 0;
            // this.cumTotal = 0;
            // this.cumTotalAttainable = 0;
            // this.total = 0;
            // this.q = 0;

            let dd = this.details[x].tab;
            for (let y in dd) {

              //map through grades array to get the number of points and grade
              for (let g in grades) {
                if (dd[y].marks >= grades[g].score) {
                  this.gradee = (!grades[g].point) ? 0 : grades[g].point;
                  //console.log(this.gradee);
                  this._point = this.gradee * dd[y].marks;
                  break;
                }
              }

              this.mark = dd[y].unit;
              this.tattained = dd[y].unit * this.gradee;
              total += this.mark;
              q += this.tattained;
              cumUnit += dd[y].unit;
              cumTotal += this.mark;
              cumTotalAttainable += this.tattained;
              // console.log('unit: ',dd[y].unit,' grade: ',this.gradee, 'x:',this.tattained);
            }

            this.details[x].tot = total;
            this.details[x].attainedGrade = q;
            this.details[x].cummulativeUnits = cumUnit;
            this.details[x].cummulativeTotal = cumTotal;
            this.details[x].cummulativeTotalAttainable = cumTotalAttainable;
            //alert(this.details[x].cummulativeTotalAttainable);       
          }

          //display tabs
          for (let i in this.sessions) {
            for (let j in this.semester_alias) {
              this.tabs.push({
                t: this.sessions[i] + "|" + this.semester_alias[j], tot: '', attainedGrade: '',
                cummulativeUnits: '', cummulativeTotal: '', cummulativeTotalAttained: ''
              });
            }
          }



          this._loaderService.emitChange(false);
          //console.log(this.details);
        })
      })
    });





    //return this.courses;


    this._userService.getUserData().subscribe(data => {
      this.studentPassport = data.passport;
      this.firstname = data.firstname;
      this.lastname = data.lastname;
      this.middlename = data.middlename;
      this.student_id = data.student_id;
      this.matric_no = data.matric_no;
      this.studentLevel = data.tag;
      this.program = data.name;
      this.dept = data.description;
      this.termd_id = data.c_termd_id;
      this.term_id = data.term_id;
      this.cd_id = data.cd_id;
      this.branch_id = data.branch_id;

      if (this.system == 'psec') {
        let form = new FormData();
        form.append("termd_id", this.details[0].tab[0].termd_id);
        form.append("term_id", this.details[0].tab[0].term_id);
        form.append("cd_id", this.details[0].tab[0].cd_id);
        form.append("branch_id", this.branch_id);
        form.append("fetch_all", this.x);
        this.cl.reportKeyGrades(form).subscribe(grade => {
          let gradeArr = JSON.parse(JSON.stringify(grade));
          for (let count = 0; count < gradeArr.length; count++) {
            let endScore = 100;
            if (count > 0) {
              endScore = gradeArr[count - 1].score - 1;
            }
            this.gradeArr[count] = [{ "min_score": gradeArr[count].score, "max_score": endScore, "grade": gradeArr[count].grade }];

          }
          // this.load.emitChange(false);
          this.computeReport(form, this.details[0].tab[0].termd_id);
        })
      }
    })
  }

  computeReport (sum, termd) {
    this.cl.classTotalReport(sum).subscribe(totalReport => {
      this.totalReportArr = JSON.parse(JSON.stringify(totalReport));
      this.totalReportArr = this.sortByKey(this.totalReportArr, "marks_obtained")
      this.totalReportArr.map((a, index) => {
        if (this.omitPosition) {
          if (index != 0 && a.marks_obtained == this.totalReportArr[index - 1].marks_obtained) {
            a.class_position = this.totalReportArr[index - 1].class_position
          } else {
            a.class_position = index + 1
          }
        } else {
          if (index != 0 && a.marks_obtained == this.totalReportArr[index - 1].marks_obtained) {
            a.class_position = this.totalReportArr[index - 1].class_position
          } else {
            a.class_position = index == 0 ? 1 : this.totalReportArr[index - 1].class_position + 1;
          }
        }
      })
      // console.log(this.totalReportArr, "REPORT ARR")
      this.cl.classReport(sum).subscribe(report => {
        // this.load.emitChange(false);
        this.reportArr = JSON.parse(JSON.stringify(report));
        this.reportArr = this.sortByKey(this.reportArr, "marks_obtained");
        this.reportArr.map((a, index) => {
          if (this.omitPosition) {
            if (index != 0 && a.marks_obtained == this.reportArr[index - 1].marks_obtained) {
              a.class_position = this.reportArr[index - 1].class_position
            } else {
              a.class_position = index + 1
            }
          } else {
            if (index != 0 && a.marks_obtained == this.reportArr[index - 1].marks_obtained) {
              a.class_position = this.reportArr[index - 1].class_position
            } else {
              a.class_position = index == 0 ? 1 : this.reportArr[index - 1].class_position + 1;
            }
          }
        })
        // console.log(this.reportArr, "REPOT ARR")
        this.reportArr.map(report => {
          let ctcomment = report.comments[0].ctcomment;
          if (ctcomment) {
            if (ctcomment.length <= 3) {
              let ctcommentObj = this.commentArr.filter(c => c.comment_id == ctcomment);
              // console.log(ctcomment, ctcommentObj, this.commentArr);

              report.comments[0].ctcomment = ctcommentObj[0].Comment;
            }
          }

          let hmcomment = report.comments[0].hmcomment;
          if (hmcomment) {
            if (hmcomment.length <= 3) {
              let hmcommentObj = this.commentArr.filter(c => c.comment_id == hmcomment);
              report.comments[0].ctcomment = hmcommentObj[0].Comment;
            }
          }

          let pcomment = report.comments[0].pcomment;
          if (pcomment) {
            if (pcomment.length <= 3) {
              let pcommentObj = this.commentArr.filter(c => c.comment_id == pcomment);
              report.comments[0].pcomment = pcommentObj[0].Comment;
            }
          }

          if (this.fetchForAll) {
            let classPositionIndex = this.totalReportArr.findIndex(x => x.termd_id == report.termd_id);
            report.class_position = this.totalReportArr[classPositionIndex].class_position;
          } else {
            let classPositionIndex = this.reportArr.findIndex(x => x.termd_id == report.termd_id);
            report.class_position = this.reportArr[classPositionIndex].class_position;
          }
          if (report.results.length > 0) {
            for (let subCount = 0; subCount < report.results.length; subCount++) {
              let co_id = report.results[subCount].co_id;
              let arr = [];
              arr.length = 0;

              if (this.fetchForAll) {
                for (let classCount = 0; classCount < this.totalReportArr.length; classCount++) {
                  let subIndex = this.totalReportArr[classCount].results.findIndex(x => x.co_id == co_id);
                  if (subIndex > -1) {
                    const { total, termd_id } = this.totalReportArr[classCount].results[subIndex];
                    arr.push({ total, termd_id });
                  }
                }
              } else {
                for (let classCount = 0; classCount < this.reportArr.length; classCount++) {
                  let subIndex = this.reportArr[classCount].results.findIndex(x => x.co_id == co_id);
                  if (subIndex > -1) {
                    const { total, termd_id } = this.reportArr[classCount].results[subIndex];
                    arr.push({ total, termd_id });
                  }
                }
              }
              arr.sort(function (a, b) {
                let keyA = parseInt(a.total);
                let keyB = parseInt(b.total);
                if (keyA > keyB) return -1;
                if (keyA < keyB) return 1;
                return 0;
              });
              arr.map((a, index) => {
                if (this.omitPosition) {
                  if (index != 0 && a.total == arr[index - 1].total) {
                    a.sub_position = arr[index - 1].sub_position
                  } else {
                    a.sub_position = index + 1
                  }
                } else {
                  if (index != 0 && a.total == arr[index - 1].total) {
                    a.sub_position = arr[index - 1].sub_position
                  } else {
                    a.sub_position = index == 0 ? 1 : arr[index - 1].sub_position + 1;
                  }
                }
              })
              // console.log(arr, co_id)
              let subPositionIndex = arr.findIndex(x => x.termd_id == report.termd_id);
              report.results[subCount]['sub_position'] = arr[subPositionIndex].sub_position;
              // console.log(subCount, report.results)
            }
            // for(let subCount=0;subCount<totalReport.results.length;subCount++){
            //   let co_id = totalReport.results[subCount].co_id;
            //   let arr=[];
            //   arr.length = 0;
            //   for(let classCount =0;classCount < this.totalReportArr.length;classCount++){
            //     let subIndex = this.totalReportArr[classCount].results.findIndex(x => x.co_id == co_id);
            //     if(subIndex>-1){
            //     const {total, termd_id} = this.totalReportArr[classCount].results[subIndex];
            //     arr.push({total,termd_id});
            //     }
            //   }
            //   arr.sort(function(a,b){
            //     let keyA = parseInt(a.total);
            //     let keyB = parseInt(b.total);
            //     if (keyA > keyB) return -1;
            //     if (keyA < keyB) return 1;
            //     return 0;
            //   });
            //   // console.log(arr, co_id)
            //   let subPositionIndex = arr.findIndex(x => x.termd_id == this.termd_id);
            //   report.results[subCount].sub_position = subPositionIndex+1;
            // }
          }
          //   // }
        })
        // console.log("BEFORE CURRENT")
        this.term_id = this.reportArr[0].term_id;
        this.sem.getSemesters().subscribe(data => {
          let terms = data;
          let index = terms.findIndex(term => term.term_id == this.term_id);
          this.currentTerm = terms[index];
          this.currentTerm.next_term_begins = terms[index + 1].begins;
          this.computeStudentReport(sum, termd)
        })

        // console.log(this.currentTerm, "CURRENT TERM")
        // this.load.emitChange(false);

        // this.cl.studentReport(this.sum).subscribe(report=>{
        // console.log()
        // console.log(this.studentReport, "S REPORT");
        // }
        // this.load.emitChange(false);
        // })
      });
    })
  }

  computeStudentReport (sum, termd_id) {
    this.computeTermReport(sum, termd_id);
    // console.log(this.reportArr, "REP ARR")
    this.studentReport = this.reportArr.filter(
      (x) => x.termd_id == termd_id
    );

    // console.log(this.studentReport, "STD REP")
    // console.log(termd_id, "TERM D ")

    let ctcomment = this.studentReport[0].comments[0].ctcomment;
    if (ctcomment) {
      if (ctcomment.length <= 3) {
        let ctcommentObj = this.commentArr.filter(c => c.comment_id == ctcomment);
        this.studentReport[0].comments[0].ctcomment = ctcommentObj[0].Comment;
      }
    }

    let hmcomment = this.studentReport[0].comments[0].hmcomment;
    if (hmcomment) {
      if (hmcomment.length <= 3) {
        let hmcommentObj = this.commentArr.filter(c => c.comment_id == hmcomment);
        this.studentReport[0].comments[0].ctcomment = hmcommentObj[0].Comment;
      }
    }

    let pcomment = this.studentReport[0].comments[0].pcomment;
    if (pcomment) {
      if (pcomment.length <= 3) {
        let pcommentObj = this.commentArr.filter(c => c.comment_id == pcomment);
        this.studentReport[0].comments[0].pcomment = pcommentObj[0].Comment;
      }
    }

    // console.log(this.studentReport, "STD REP")
    // let classPositionIndex = this.reportArr.findIndex(x => x.termd_id == this.termd_id);
    // this.studentReport[0].class_position = classPositionIndex+1;
    // if (this.studentReport[0].results.length > 0) {
    for (let subCount = 0; subCount < this.studentReport[0].results.length; subCount++) {
      let co_id = this.studentReport[0].results[subCount].co_id;
      let arr = [];
      arr.length = 0;
      if (this.fetchForAll) {
        for (let classCount = 0; classCount < this.totalReportArr.length; classCount++) {
          let subIndex = this.totalReportArr[classCount].results.findIndex(x => x.co_id == co_id);
          if (subIndex > -1) {
            const { total, termd_id } = this.totalReportArr[classCount].results[subIndex];
            arr.push({ total, termd_id });
          }
        }
      } else {
        for (let classCount = 0; classCount < this.reportArr.length; classCount++) {
          let subIndex = this.reportArr[classCount].results.findIndex(x => x.co_id == co_id);
          if (subIndex > -1) {
            const { total, termd_id } = this.reportArr[classCount].results[subIndex];
            arr.push({ total, termd_id });
          }
        }
      }

      arr.sort(function (a, b) {
        let keyA = parseInt(a.total);
        let keyB = parseInt(b.total);
        if (keyA > keyB) return -1;
        if (keyA < keyB) return 1;
        return 0;
      });

      arr.map((a, index) => {
        if (index != 0 && a.total == arr[index - 1].total) {
          a.sub_position = arr[index - 1].sub_position
        } else {
          a.sub_position = index == 0 ? 1 : arr[index - 1].sub_position + 1;
        }
      })
      // console.log(arr, co_id, this.termd_id)
      let subPositionIndex = arr.findIndex(x => x.termd_id == this.termd_id);
      this.studentReport[0].results[subCount].sub_position = arr[subPositionIndex].sub_position;
    }
  }


  computeTermReport (sum, termd_id) {
    this.studentTermReport.length = 0;
    // console.log(termd_id, "TERRRRRMMMMMMM DDDDDDDD")
    this.cl.getTermSettings().subscribe((term_setttings) => {
      this.term1 = term_setttings.term1;
      this.term2 = term_setttings.term2;
      this.term3 = term_setttings.term3;
      this.cl.classTotalTermReport(sum).subscribe((totalReport) => {
        this.classTotalTermReport = JSON.parse(
          JSON.stringify(totalReport)
        );
        this.classTotalTermReport = this.sortByKey(
          this.classTotalTermReport,
          "marks_obtained"
        );
        this.cl.classTermReport(sum).subscribe((data) => {
          this.classTermReport = JSON.parse(JSON.stringify(data));
          // console.log(this.classTermReport, 'WHOLE TERM REP');
          this.term_id = this.classTermReport[0].term_id;
          this.classTermReport = this.sortByKey(
            this.classTermReport,
            "marks_obtained"
          );
          this.classTermReport.map((student) => {
            let ctcomment = student.comments[0].ctcomment;
            if (ctcomment) {
              if (ctcomment.length <= 3) {
                let ctcommentObj = this.commentArr.filter(
                  (c) => c.comment_id == ctcomment
                );
                student.comments[0].ctcomment = ctcommentObj[0].Comment;
              } else {
              }
            }
            // console.log(student, "After assignment");

            let hmcomment = student.comments[0].hmcomment;
            if (hmcomment) {
              if (hmcomment.length <= 3) {
                let hmcommentObj = this.commentArr.filter(
                  (c) => c.comment_id == hmcomment
                );
                student.comments[0].hmcomment = hmcommentObj[0].Comment;
              }
            }

            let pcomment = student.comments[0].pcomment;
            if (pcomment) {
              if (pcomment.length <= 3) {
                let pcommentObj = this.commentArr.filter(
                  (c) => c.comment_id == pcomment
                );
                student.comments[0].pcomment = pcommentObj[0].Comment;
              }
            }
            let total_average = 0;
            student.subjects.map((subject) => {
              total_average += parseFloat(subject.average);
              subject.weighted_arr.map((weight) => {
                if (weight.current) {
                  subject.current_weight = weight;
                }
              });
            });

            let round_average: any =
              total_average / student.subjects.length;
            round_average = (
              Math.round(round_average * 100) / 100
            ).toFixed(2);
            student.ave = round_average;
          });

          this.studentTermReport = this.classTermReport.filter(
            (x) => x.termd_id == termd_id
          );

          // console.log(this.studentTermReport, termd_id, "ST TERM RPT");

          if (this.studentTermReport.length > 0) {
            let classPositionIndex = this.classTotalTermReport.findIndex(
              (x) => x.termd_id == termd_id
            );
            this.studentTermReport[0].class_position =
              classPositionIndex + 1;

            // if(this.studentTermReport[0].subjects.length > 0){
            for (
              let subCount = 0;
              subCount < this.studentTermReport[0].subjects.length;
              subCount++
            ) {
              let sub_id =
                this.studentTermReport[0].subjects[subCount].sub_id;
              // console.log(sub_id);
              let arr = [];

              for (
                let classCount = 0;
                classCount < this.classTotalTermReport.length;
                classCount++
              ) {
                let subIndex = this.classTotalTermReport[
                  classCount
                ].subjects.findIndex((x) => x.sub_id == sub_id);
                if (subIndex > -1) {
                  const { total, termd_id, average } =
                    this.classTotalTermReport[classCount].subjects[
                    subIndex
                    ];
                  arr.push({ total, termd_id, average });
                }
              }
              arr.sort(function (a, b) {
                let keyA = parseInt(a.average);
                let keyB = parseInt(b.average);
                if (keyA > keyB) return -1;
                if (keyA < keyB) return 1;
                return 0;
              });

              let subPositionIndex = arr.findIndex(
                (x) => x.termd_id == termd_id
              );
              if (subPositionIndex) {
                this.studentTermReport[0].subjects[
                  subCount
                ].sub_position = subPositionIndex + 1;
                this.studentTermReport[0].subjects.map((subject) => {
                  subject.weighted_arr.map((weight) => {
                    if (weight.current) {
                      subject.current_weight = weight;
                    }
                  });
                });
              }
            }
            // }
          }
        });
      });
    });
  }


  payForResult () {
    this._resultService.payForResult({ payment: 'result' }).subscribe(data => {
      this.log
        .addLog({
          action: "Pay",
          component: `${this.system == 'tert' ? 'Semester' : 'Term'} Result`,
          details: `Made Payment for ${this.system == 'tert' ? 'Semester' : 'Term'} Result`,
        }).subscribe(data => { });
      location.href = data.red_url;

    })
  }

  tabChange (e) {
    // console.log(this.details[e.index], "DET IND");
    this.session_year = this.details[e.index].session_year;
    this.semester = this.details[e.index].semester;

    this.program = this.details[e.index].tab[0].name;
    this.studentLevel = this.details[e.index].tab[0].tag;
    let termd_id = this.details[e.index].tab[0].termd_id;
    let term_id = this.details[e.index].tab[0].term_id;
    let cat_id = this.details[e.index].tab[0].cat_id;
    let c_id = this.details[e.index].tab[0].c_id;
    let cd_id = this.details[e.index].tab[0].cd_id;

    this.classTermReport.length = 0;
    this.classTotalTermReport.length = 0;
    this.studentTermReport.length = 0;
    this.studentReport.length = 0;

    // console.log(termd_id, "TERM D.1")
    this.cl.ResultEntrySettings({ keys: true, c_id, cat_id }).subscribe((data) => {
      this.resultSetArr = JSON.parse(JSON.stringify(data));


      this.ca1 = this.resultSetArr[0].value;
      this.ca1Name = this.resultSetArr[0].settings_name;
      this.controlCA1 = this.resultSetArr[0].visibility;

      this.ca2 = this.resultSetArr[1].value;
      this.ca2Name = this.resultSetArr[1].settings_name;
      this.controlCA2 = this.resultSetArr[1].visibility;

      this.exam = this.resultSetArr[2].value;
      this.examName = this.resultSetArr[2].settings_name;
      this.controlExam = this.resultSetArr[2].visibility;

      let total = 0;
      this.resultSetArr.map((r) => {
        // console.log()
        try {
          this.obtainable[r.column_name] = r.value;
          total += Number(r.value);
        } catch (e) {
          // console.log(e);
        }
      });
      this.obtainable["total"] = total;
      let form = new FormData();
      form.append("termd_id", termd_id);
      form.append("term_id", term_id);
      form.append("cd_id", cd_id);
      form.append("branch_id", this.branch_id);

      this.cl.reportKeyGrades(form).subscribe(grade => {
        let gradeArr = JSON.parse(JSON.stringify(grade));
        for (let count = 0; count < gradeArr.length; count++) {
          let endScore = 100;
          if (count > 0) {
            endScore = gradeArr[count - 1].score - 1;
          }
          this.gradeArr[count] = [{ "min_score": gradeArr[count].score, "max_score": endScore, "grade": gradeArr[count].grade }];

        }
        // this.load.emitChange(false);
        // this.computeReport(form, this.details[0].tab[0].termd_id);
        this.computeReport(form, termd_id)
      })
    });
  }

  print () {
    if (!this.company?.allow_portal_result_print) return;

    this.log
      .addLog({
        action: "Print",
        component: `${this.system == 'tert' ? 'Semester' : 'Term'} Result`,
        details: `Printed ${this.system == 'tert' ? 'Semester' : 'Term'} Result`,
      }).subscribe(data => { });
    let mywindow = window.open('', 'PRINT', 'height=700,width=1000');
    mywindow.document.write('<html><head><title>' + document.title + '</title>');
    mywindow.document.write(
      "<style>body{font-family:arial;} div{float:left;} table{background-color:#fff;border-collapse:collapse;width:100%;font-family:arial;font-size:0.85em;border:solid 1px #ccc;margin-top:20px;} th, td{border:solid 1px #ccc;padding:8px 5px; text-align:left;} img{width:50px;height:50px} table#summary tr td{padding-top:40px;text-align:center;} .clearfix{clear:both} table,table#details tr td{border:none}</style>"
    );
    mywindow.document.write("</head><body>");
    mywindow.document.write("<div style='width:15%'>")
    mywindow.document.write("<img src='" + this.company?.logo + "'>");
    mywindow.document.write("</div>");

    mywindow.document.write("<div style='width:85%'>")
    mywindow.document.write("<span><strong>" + this.company?.name + "</strong></span><br>");
    mywindow.document.write("<span><small>" + this.company?.address + "</small></span>");
    mywindow.document.write("</div>");
    mywindow.document.write("<div style='width:100%'><hr style='color:#ccc'></div>");
    mywindow.document.write("<div class='clearfix'></div>");

    mywindow.document.write("<div style='width:70%'>");
    mywindow.document.write(`<table id='details'><tr style="text-transform: uppercase"><td style=width:35%'>Name:</td><td style='width:65%'>${this.lastname} ${this.firstname} ${this.middlename} </td></tr><tr><td style=width:35%'>Dept:</td><td style='width:65%'>${this.dept}</td></tr>`);
    if (this.company?.adm_initial == 'ADECOM') {
      mywindow.document.write("<tr><td>Registration Number:</td><td>" + this.matric_no + "</td></tr></table>");
    } else {
      mywindow.document.write("<tr><td>Matric Number:</td><td>" + this.matric_no + "</td></tr></table>");
    }
    mywindow.document.write(`<p>${this.session_year} - ${this.semester} RESULT </p>`);
    mywindow.document.write(`<p><small>Level: ${this.program} - <span style="text-transform: uppercase">${this.studentLevel}</span></small> </p>`);
    mywindow.document.write("</div>");

    mywindow.document.write("<div style='width:30%;text-align:right;'>");
    mywindow.document.write("<img style='border-radius:50%;' src='" + this.studentPassport + "'>");
    mywindow.document.write("</div>");

    mywindow.document.write(document.getElementById('toBePrinted').innerHTML);

    mywindow.document.write("<table id='summary' style='border:none;margin-top:20px'><tr><td style='border:none;width:33.33%'><hr />Student</td><td style='border:none;width:33.33%;'><hr /> HOD</td><td style='border:none;width:33.33%;'><hr />F. Advisor</td></tr><tr><br /><br /><td style='border:none;width:33.33%'><hr />DSA</td><td style='border:none;width:33.33%;'><hr /> Student Body</td><td style='border:none;width:33.33%;'><hr />Bursar</td></tr></table>")

    mywindow.document.write('</body></html>');

    mywindow.document.close(); // necessary for IE >= 10
    mywindow.focus(); // necessary for IE >= 10*/
    mywindow.print();
    // mywindow.close();

    return true;
  }


  printPsec () {
    if (!this.company?.allow_portal_result_print) return;

    this.log
      .addLog({
        action: "Print",
        component: `${this.system == 'tert' ? 'Semester' : 'Term'} Result`,
        details: `Printed ${this.system == 'tert' ? 'Semester' : 'Term'} Result`,
      }).subscribe(data => { });
    // console.log(this.studentReport);
    let prn = window.open('', 'PRINT', 'height=700,width=1000');
    prn.document.write('<html><head><title>' + document.title + " - " +
      this.studentReport[0].term.toUpperCase() + " - " +
      this.studentReport[0].session_year.toUpperCase() + " - " +
      this.studentReport[0].matric_no.toUpperCase() + '</title>');
    prn.document.write('<body>');
    // prn.document.getElementById('singlePrint').style.background = `url(${this.company.logo})`;
    prn.document.write(document.getElementById('singlePrint').innerHTML);
    prn.document.write('</body>');
    prn.document.write('</html>');
    prn.document.close(); // necessary for IE >= 10

    prn.print();
  }


  printTermReport () {
    if (!this.company?.allow_portal_result_print) return;

    this.log
      .addLog({
        action: "Print",
        component: `${this.system == 'tert' ? 'Semester' : 'Term'} Result`,
        details: `${this.system == 'tert' ? 'Semester' : 'Term'} Term Report`,
      }).subscribe(data => { });
    if (this.studentTermReport.length > 0) {
      let mywindow = window.open("", "PRINT", "height=842,width=595");
      mywindow.document.write(
        `<html><head><title>
        TERM REPORT - ${this.studentTermReport[0].lastname} - ${this.studentTermReport[0].matric_no
        }-  ${this.studentReport[0].name.toUpperCase()} -  ${this.studentReport[0].category.toUpperCase()} - ${this.studentReport[0].tag.toUpperCase()}
            - ${this.studentReport[0].term.toUpperCase()} - ${this.studentReport[0].session_year.toUpperCase()}
        </title><body><div style="width: 100%">`
      );
      mywindow.document.write(
        `
          <table style="width: 100%;">
            <tr>
                <td>
                <img src=" ${this.company.logo
        }" style="  width:80px;height:80px" />

                </td>
                <td>
                    <strong style="font-size: 2em">${this.company?.name.toUpperCase()}</strong>
                    <div>
                        <i id="comp_address"></i>
                    </div>
                </td>
            </tr>
            <tr>
                <td colspan="2">
                    <div style='width:100%;border-top:2px solid black;margin-top:3px'>
                    </div>
                </td>
            </tr>
          </table>
     `
      );
      mywindow.document.getElementById("comp_address").innerHTML =
        this.company?.address;
      // mywindow.document.write(
      //   `<div style="position:relative;top:-5px;margin-top:5px;margin-bottom:5px;border:1px solid lightgrey;width:100%;float:left;z-index:1000"></div>`
      // );
      mywindow.document.write(
        `<form id="box1">
        <fieldset>
        <legend>Student Info</legend>
        <table width="100%" border="0" cellspacing="0" cellpadding="0" >
          <tr>
            <td rowspan="6" valign="top"><img name="" class="border" src="${this.studentTermReport[0].passport
        }" onerror="this.src='assets/img/man.png'" style="margin-right: 20px" width="98" height="81" alt="Passport missing"  /></td>
            <td width="20%"><b>Student Name</b></td>
            <td width="50%"><span class="name" style="text-transform:uppercase;"> <b>${this.studentTermReport[0].lastname
        }</b> ${this.studentTermReport[0].firstname} ${this.studentTermReport[0].middlename
        } </td>
            <td width="20%"><b>Student ID</b>.</td>
            <td width="10%">${this.studentTermReport[0].matric_no}</td>
            <td width="32">&nbsp;</td>
            <td width="32">&nbsp;</td>
            <td width="44">&nbsp;</td>
          </tr>
          <tr>
            <td width="20%"><b>Number In Class</b></td>
            <td>${this.fetchForAll ? this.classTotalTermReport.length : this.classTermReport.length}</td>
            <td><b>Gender</b></td>
            <td>${this.studentTermReport[0].gender}</td>
            <td>&nbsp;</td>
            <td>&nbsp;</td>
            <td>&nbsp;</td>
          </tr>
          <tr>
            <td><b>Class</b></td>
            <td style="text-transform:uppercase;">${this.studentTermReport[0].category
        } - ${this.studentTermReport[0].name} - ${this.studentTermReport[0].tag
        }</td>
            <td>${this.showDOB ? "<b>DOB</b>" : "&nbsp;"}</td>
            <td>${this.showDOB
          ? this.formatDate(this.studentTermReport[0].date_of_birth)
          : "&nbsp;"
        }</td>
            <td>&nbsp;</td>
          </tr>
          <tr align="center" valign="bottom" style="background: white; color: black; font-weight: bolder">
            <td colspan="6" style="text-transform:uppercase;"><font size="3">RESULT FOR ${this.studentReport[0].session_year.toUpperCase()} ${this.studentReport[0].term
        }</font></td>
            <td>&nbsp;</td>
          </tr>
        </table>
        </fieldset>
    </form>
          `
      );
      // mywindow.document.write(
      //   `<div style="position:relative;top:10px;border:1px solid lightgrey;width:100%;float:left"></div>`
      // );
      // mywindow.document.write(
      //   `<h4 align='center' style='padding-top:5px'>WEIGHTED RESULT FOR ${this.studentReport[0].session_year.toUpperCase()} . CURRENT TERM =  ${this.studentReport[0].term.toUpperCase()} </h4>`
      // );
      // mywindow.document.write(
      //   `<div style="position:relative;top:-10px;border:1px solid lightgrey;width:100%;float:left"></div>`
      // );
      mywindow.document.write(document.getElementById("termReport").innerHTML);

      mywindow.document.write(`</div></body></html>`);
      mywindow.document.close(); // necessary for IE >= 10
      mywindow.focus(); // necessary for IE >= 10*/
      mywindow.print();
      // this.load.emitChange(false);
    }
  }
  // currentTab(event){
  //   let selectedTab = event.tab.textLabel;
  //   let session = selectedTab.split('|')[0];
  //   let semester = selectedTab.split('|')[1];
  //   if(semester == "F"){
  //     semester = "First Semester";
  //   }else if(semester == "S"){
  //     semester = "Second Semester";
  //   }
  //   this.reg = this.data.filter(x => x.session_year == session && x.term == semester);
  //   //console.log(this.reg);
  //   this.total = 0;
  //   this.q = 0;
  //   this.cumUnit = 0;
  //   this.cumTotal = 0;
  //   this.cumTotalAttained = 0;
  //   for(let y in this.tabs){
  //   for(let x in this.reg){
  //     let dd = this.reg;
  //        if(dd[x].marks <= 100 && dd[x].marks >= 70){
  //         this.gradee = 5;
  //       }else if(dd[x].marks <= 69 && dd[x].marks >= 60){
  //         this.gradee = 4;
  //       }else if(dd[x].marks <= 59 && dd[x].marks >= 50){
  //         this.gradee = 3;
  //       }else if(dd[x].marks <= 49 && dd[x].marks >= 45){
  //         this.gradee = 2;
  //       }else if(dd[x].marks <= 44 && dd[x].marks >= 40){
  //         this.gradee = 1;
  //       }else if(dd[x].marks <= 39 && dd[x].marks >= 0){
  //         this.gradee = 0;
  //       }
  //       this.mark = dd[x].unit;
  //       this.tattained = dd[x].unit * this.gradee;
  //       this.total += this.mark;
  //       this.q += this.tattained;
  //       this.cumUnit += dd[x].unit;
  //       this.cumTotal += this.mark;
  //       this.cumTotalAttained += this.tattained; 

  //       this.cumUnit2 += dd[x].unit;
  //       this.cumTotal2 += this.mark;
  //       this.cumTotalAttained2 += this.tattained;
  //     // this.tabs[x].tot = this.total;
  //     // this.tabs[x].attainedGrade = this.q;

  //     // this.tabs[x].cummulativeUnits = this.cumUnit;
  //     // this.tabs[x].cummulativeTotal = this.cumTotal;
  //     // this.tabs[x].cummulativeTotalAttainable = this.cumTotalAttainable;
  //     //alert(this.tabs[x].cummulativeTotalAttainable/this.tabs[x].cummulativeTotal);
  //   }
  //   this.tabs[y].tot = this.total;
  //     this.tabs[y].attainedGrade = this.q;

  //     this.tabs[y].cummulativeUnits = this.cumUnit;
  //     this.tabs[y].cummulativeTotal = this.cumTotal;
  //     this.tabs[y].cummulativeTotalAttained = this.cumTotalAttained;
  //     //alert(this.tabs[y].cummulativeTotalAttained/this.tabs[y].cummulativeTotal);

  // }

  //     this.cumUnit = this.cumUnit;
  //     this.cumTotal = this.cumTotal;
  //     this.cumTotalAttained = this.cumTotalAttained;

  //     this.cumUnit2 = this.cumUnit2;
  //     this.cumTotal2 = this.cumTotal2;
  //     this.cumTotalAttained2 = this.cumTotalAttained2;
  // }



}
